import { IDownloadInfo } from "./../interfaces/download-info";
import { ResultModel } from "./result";
import { ISearchResultUI } from "./../interfaces/result-ui";
import { SearchModel } from "./search";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import {prop} from "../../decorators/property";
import { AppEvents } from "../../app-events";
import { Container } from "aurelia-dependency-injection";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const maxFilesInOneDownload = 50;

export enum DownloadMode {
    DownloadSelected,
    DownloadThisPage,
    DownloadTop50
}

export class SearchDownloadModel extends Backbone.Model {
    @prop() public checkboxesEnabled = false;
    @prop() public numDocsSelected = 0;
    @prop() public includeMetadata = false;
    @prop() public loading = false;
    @prop() public DownloadMode = DownloadMode.DownloadSelected;
    @prop() public searchModel: SearchModel;
    @prop() private docKeysToDownload: string[] = [];

    private appEvents: Backbone.Events;

    constructor(searchModel: SearchModel) {
        super();
        this.searchModel = searchModel;
        this.appEvents = ContainerHelper.Events;
    }

    public reset() {
        this.docKeysToDownload = [];
        this.checkboxesEnabled = false;
        this.numDocsSelected = 0;
        this.loading = false;
        this.includeMetadata = false;
        this.trigger("reset");
    }

    public clearSelectedDocKeys() {
        this.docKeysToDownload = [];
    }

    public addOrRemoveDocKey(m: ResultModel): boolean {
        if (_.contains(this.docKeysToDownload, m.Id)) {
            this.docKeysToDownload = _.without(this.docKeysToDownload, m.Id);
        } else {
            if (this.docKeysToDownload.length >= maxFilesInOneDownload) {
                return false;
            } else if (this.checkboxesEnabled) {
                this.docKeysToDownload.push(m.Id);
            }
        }
        this.numDocsSelected = this.docKeysToDownload.length;

        return true;
    }

    public getQueryStringBase() {
        let base = "?pdf=true&allReports=true";
        if (this.includeMetadata) {
            base += "&overview=true&citedcases=true&citingcases=true";
        }
        base += "&includeinventory=true&dockey=";
        return base;
    }

    public getSelectedDownloadInfo(): Promise<IDownloadInfo> {
        return new Promise((resolve, reject) => {
            const base = this.getQueryStringBase();
            const selectedJoined = this.docKeysToDownload.join("&docKey=");

            this.appEvents.trigger(AppEvents.AppInsightsSearchDownload, {type: "Download Selected", count: this.docKeysToDownload.length, query: base + selectedJoined});

            const info: IDownloadInfo = {
                TokenId: this.docKeysToDownload[0],
                QueryStringParams: base + selectedJoined,
                Callback: () => {
                    this.loading = false;
                    this.checkboxesEnabled = false;
                }
            };
            resolve(info);
        });
    }

    public getThisPageDownloadInfo(): Promise<IDownloadInfo> {
        return new Promise((resolve, reject) => {
            const base = this.getQueryStringBase();
            const selected = [];
            const current = this.searchModel.Results.forEach((result: ResultModel) => {
                selected.push(result.Id);
            });
            const selectedJoined = selected.join("&docKey=");

            this.appEvents.trigger(AppEvents.AppInsightsSearchDownload, {type: "Download Current Page", count: selected.length, query: base + selectedJoined});

            const info: IDownloadInfo = {
                TokenId: selected[0],
                QueryStringParams: base + selectedJoined,
                Callback: () => {
                    this.loading = false;
                    this.checkboxesEnabled = false;
                }
            };
            resolve(info);
        });
    }

    public isThisMarkedForDownload(docKey: string) {
        return _.contains(this.docKeysToDownload, docKey);
    }

    public getTop50DownloadInfo(): Promise<IDownloadInfo> {
        return new Promise((resolve, reject) => {
            const data = this.searchModel.assembleSearchQueryData({ResultsPerPage: 50});
            const url = this.searchModel.urlRoot + "/1";

            this.searchModel.getUserSettingsForServer().then((userSettings) => {
                $.ajax({
                    beforeSend: AuthorizationModel.attachAuthorizationHeader,
                    method: "POST",
                    url: url,
                    headers: {
                        UserSettings: userSettings
                    },
                    contentType: "application/json",
                    dataType: "json",
                    data: data,
                    success: (response) => {
                        const results = (response as any).Results;
                        const keys = _.map(results, (r: any) => r.Id);
                        const base = this.getQueryStringBase();
                        const selectedJoined = keys.join("&docKey=");

                        this.appEvents.trigger(AppEvents.AppInsightsSearchDownload, {type: "Download Top 50", count: keys.length, query: base + selectedJoined});

                        const info: IDownloadInfo = {
                            TokenId: keys[0],
                            QueryStringParams: base + selectedJoined,
                            Callback: () => {
                                this.loading = false;
                                this.checkboxesEnabled = false;
                            }
                        };
                        resolve(info);
                    },
                    error: (response) => {
                        this.loading = false;
                        reject(response);
                    }
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/search-download.ts